export interface PositionPreset {
  id: string
  name: string
  thumbnail: string | null
  triggerWord: string | null
  readableName: string | null
}

export const POSITION_PRESETS: PositionPreset[] = [
  {
    id: 'reverse_cowgirl',
    name: 'Reverse Cowgirl',
    thumbnail: '/positions/reverse-cowgirl.svg',
    triggerWord: 'r3v3rs3_c0wg1rl',
    readableName: 'reverse cowgirl position',
  },
  {
    id: 'doggy',
    name: 'Doggy Style',
    thumbnail: '/positions/doggy.svg',
    triggerWord: 'd0gg13',
    readableName: 'doggy style position',
  },
  {
    id: 'missionary',
    name: 'Missionary',
    thumbnail: '/positions/missionary.svg',
    triggerWord: 'm15510n4ry',
    readableName: 'missionary position',
  },
  {
    id: 'blowjob',
    name: 'Blowjob',
    thumbnail: '/positions/blowjob.svg',
    triggerWord: 'bl0wj0b',
    readableName: 'blowjob',
  },
]
